import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { EnableClassTelemetry } from 'app/services/otel.service';

export enum ScreenWidthNames {
  Default = 'default',
  Web = 'web',
  Tablet = 'tablet',
  Handset = 'handset',
}

enum ScreenWidths {
  xSmall = '(min-width: 599px)',
  small = '(min-width: 839px)',
  medium = '(min-width: 1099px)',
  large = '(min-width: 1440px)',
}

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private breakPointSubject = new ReplaySubject<ScreenWidthNames>();
  private isSidePanelOpenSubject = new ReplaySubject<boolean>();

  readonly breakpoint$ = this.breakpointObserver
    .observe([ScreenWidths.large, ScreenWidths.medium, ScreenWidths.small, ScreenWidths.xSmall])
    .pipe(distinctUntilChanged());

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpoint$.subscribe(() => this.breakpointChanged());
  }

  private breakpointChanged() {
    if (this.breakpointObserver.isMatched(ScreenWidths.large)) {
      this.breakPointSubject.next(ScreenWidthNames.Default);
    } else if (this.breakpointObserver.isMatched(ScreenWidths.medium)) {
      this.breakPointSubject.next(ScreenWidthNames.Web);
    } else if (this.breakpointObserver.isMatched(ScreenWidths.small)) {
      this.breakPointSubject.next(ScreenWidthNames.Tablet);
    } else if (this.breakpointObserver.isMatched(ScreenWidths.xSmall)) {
      this.breakPointSubject.next(ScreenWidthNames.Handset);
    }
  }

  getCurrentBreakPoint(): Observable<string> {
    return this.breakPointSubject.asObservable();
  }

  getIsSidePanelOpen(): Observable<boolean> {
    return this.isSidePanelOpenSubject.asObservable();
  }

  setIsSidePanelOpen(isOpen: boolean) {
    this.isSidePanelOpenSubject.next(isOpen);
  }
}
